import { render, staticRenderFns } from "./LoadVerificationButtons.vue?vue&type=template&id=53a235ce"
import script from "./LoadVerificationButtons.vue?vue&type=script&lang=js"
export * from "./LoadVerificationButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports